import firebase from "firebase/app";
import "firebase/auth";
var firebaseConfig = {
  apiKey: "AIzaSyAMrwlQjPNvnH4BTZptoGqcL2UZW3rAkBc",
  authDomain: "nfoproject-35290.firebaseapp.com",
  projectId: "nfoproject-35290",
  storageBucket: "nfoproject-35290.appspot.com",
  messagingSenderId: "1028813510757",
  appId: "1:1028813510757:web:f0f9032d63d2bea2528e8c",
};

firebase.initializeApp(firebaseConfig);
firebase.auth().useDeviceLanguage();
const auth = firebase.auth();
export default auth;
